module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Buried-Knights-Templar-1.64245e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Buried-Knights-Templar-1.jpg
// module id = G+6K
// module chunks = 0